// extracted by mini-css-extract-plugin
export default {"main_schedule_home":"ScheduleHome_main_schedule_home__0nhau","main_content_book":"ScheduleHome_main_content_book__MkmgD","centilio_sign":"ScheduleHome_centilio_sign__oPrJJ"};